/* Source media is attached only after a customer chooses a clip. */
(() => {
  const root = document.querySelector('[data-customer-clips]');
  if (!root || root.dataset.clipsReady) return;
  const destination = document.querySelector('#main .setting-feature');
  if (!destination) return;
  destination.before(root);
  root.hidden = false;
  root.dataset.clipsReady = 'true';
  const track = root.querySelector('.ds-clips-track');
  const cards = [...track.querySelectorAll('[data-clip]')];
  const dialog = root.querySelector('dialog');
  const video = dialog.querySelector('video');
  const status = dialog.querySelector('[data-clip-status]');
  const scrollButtons = [...root.querySelectorAll('[data-clips-scroll]')];
  let current = 0;
  let launcher;
  let frame = 0;
  let playbackAttempt = 0;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const loadPoster = image => {
    if (!image.dataset.clipSrc) return;
    image.srcset = image.dataset.clipSrcset;
    image.src = image.dataset.clipSrc;
    delete image.dataset.clipSrc;
    delete image.dataset.clipSrcset;
  };
  if ('IntersectionObserver' in window) {
    const posterObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        loadPoster(entry.target);
        posterObserver.unobserve(entry.target);
      });
    }, { root: track, rootMargin: '0px 240px', threshold: 0 });
    const sectionObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      cards.forEach(card => posterObserver.observe(card.querySelector('img')));
      sectionObserver.disconnect();
    }, { rootMargin: '300px 0px', threshold: 0 });
    sectionObserver.observe(root);
  } else cards.forEach(card => loadPoster(card.querySelector('img')));
  function updateNavigation() {
    frame = 0;
    const bounds = track.getBoundingClientRect();
    const visible = cards.map((card, index) => ({index, rect: card.getBoundingClientRect()})).filter(item => item.rect.right > bounds.left + 8 && item.rect.left < bounds.right - 8);
    if (visible.length) root.querySelector('[data-clips-range]').textContent = `${String(visible[0].index + 1).padStart(2, '0')}—${String(visible.at(-1).index + 1).padStart(2, '0')} / ${cards.length} moments`;
    scrollButtons[0].disabled = track.scrollLeft <= 2;
    scrollButtons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }
  const scheduleNavigation = () => { if (!frame) frame = requestAnimationFrame(updateNavigation); };
  const scroll = direction => track.scrollBy({left: direction * (cards[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap)) * Math.max(1, Math.floor(track.clientWidth / cards[0].offsetWidth)), behavior: motion()});
  scrollButtons.forEach(button => button.addEventListener('click', () => scroll(Number(button.dataset.clipsScroll))));
  track.addEventListener('scroll', scheduleNavigation, {passive:true});
  track.addEventListener('keydown', event => {
    if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault(); scroll(event.key === 'ArrowRight' ? 1 : -1);
  });
  if ('ResizeObserver' in window) new ResizeObserver(scheduleNavigation).observe(track);
  else window.addEventListener('resize', scheduleNavigation, {passive:true});
  function releaseVideo() {
    playbackAttempt++;
    video.pause();
    video.removeAttribute('src');
    video.removeAttribute('poster');
    video.load();
  }
  function showClip(index) {
    current = (index + cards.length) % cards.length;
    releaseVideo();
    const attempt = playbackAttempt;
    const card = cards[current];
    dialog.querySelector('#ds-clips-player-title').textContent = `Customer moment ${String(current + 1).padStart(2, '0')}`;
    dialog.querySelector('[data-clip-count]').textContent = `${current + 1} / ${cards.length}`;
    status.hidden = true;
    video.poster = card.dataset.poster;
    video.setAttribute('aria-label', `Diamond Studio customer clip ${current + 1} of ${cards.length}`);
    video.src = card.dataset.video;
    video.play().catch(() => {
      if (attempt !== playbackAttempt || !dialog.open) return;
      status.textContent = video.error ? 'This clip could not load. Please try another moment or try again.' : 'Press play to watch this customer moment.';
      status.hidden = false;
    });
  }
  cards.forEach((card, index) => card.addEventListener('click', () => {
    launcher = card;
    dialog.showModal();
    document.documentElement.classList.add('ds-clips-open');
    showClip(index);
  }));
  dialog.querySelector('[data-clip-close]').addEventListener('click', () => dialog.close());
  dialog.querySelectorAll('[data-clip-step]').forEach(button => button.addEventListener('click', () => showClip(current + Number(button.dataset.clipStep))));
  video.addEventListener('playing', () => { status.hidden = true; });
  video.addEventListener('error', () => {
    if (!dialog.open || !video.hasAttribute('src')) return;
    status.textContent = 'This clip could not load. Please try another moment or try again.';
    status.hidden = false;
  });
  dialog.addEventListener('close', () => {
    releaseVideo();
    document.documentElement.classList.remove('ds-clips-open');
    launcher?.focus({preventScroll:true});
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
  window.addEventListener('pagehide', () => { if (dialog.open) dialog.close(); });
  updateNavigation();
})();
